/* eslint-disable import/prefer-default-export */
export const LD_EXPERIMENT_FLAG_KEY = 'projects-exp-32-help-modal-revision';
